/* eslint-disable no-undef */
/* eslint-disable */
jQuery(document).ready(() => {
  jQuery('body').on('click', '.card-video', function () {
    jQuery('#lb-video-to-play').attr('src', jQuery(this).children('img').attr('video-url'));
    jQuery('#lb-info-video-name').html(jQuery(this).children('h3').html());
    jQuery('#lb-info-video-data').html(jQuery(this).children('span').html());
    jQuery('#lb-video').show();
    jQuery('#lb-info-video').show();
    jQuery('.overlay').fadeIn();

    jQuery('.overlay, .lightbox').addClass('lightbox--show').fadeIn();

    jQuery('#media-video-back').attr('media', parseInt(jQuery(this).attr('media')) - 1);
    jQuery('#media-video-next').attr('media', parseInt(jQuery(this).attr('media')) + 1);

    if (jQuery('.card-video').size() > 1) {
      jQuery('#media-video-back, #media-video-next').show();
    }

    if (jQuery(this).attr('media') == jQuery('.card-video').size()) {
      jQuery('#media-video-next').hide();
    }

    if (jQuery('.card-video').size() == 1) {
      jQuery('#media-video-back, #media-video-next').hide();
    }

    if (jQuery(this).attr('media') == 1) {
      jQuery('#media-video-back').hide();
    }
  });

  //----------------------------------------------------------------------------------------------------------------------

  jQuery('.lightbox .icon-g-close').on('click', function () {
    jQuery(this).parent().hide();
    jQuery('#lb-video-to-play').attr('src', '');
    jQuery('.overlay, .lightbox').removeClass('lightbox--show');
    jQuery('.overlay').fadeOut('slow');
  });

  //----------------------------------------------------------------------------------------------------------------------

  jQuery('.overlay').on('click', () => {
    jQuery('.overlay, .lightbox').removeClass('lightbox--show');
    jQuery('.overlay').fadeOut('slow');
  });

  //----------------------------------------------------------------------------------------------------------------------

  jQuery('body').on('click', '.item-tag-image', function () {
    const img_url = jQuery(this).children('img').attr('img-url-cropped');
    const img_title = jQuery(this).children('img').attr('img-name');
    post_related = '';

    jQuery('#img-excerpt').html(jQuery(this).children('p').html());
    jQuery('#img-tag-lightbox').attr('src', img_url);
    jQuery('#lb-img-name').html(img_title);

    jQuery('#img-tag-lightbox, lb-img-name').fadeIn();
    jQuery('.overlay, .lightbox').addClass('lightbox--show').fadeIn();
    jQuery('#media-back').attr('media', parseInt(jQuery(this).attr('media')) - 1);
    jQuery('#media-next').attr('media', parseInt(jQuery(this).attr('media')) + 1);

    var post_related = jQuery(this).children('img').attr('img-post-related');

    if (post_related != 'false' && post_related != '') {
      jQuery('.see-content').attr('href', post_related).html('Leia a matéria').show();
    } else {
      jQuery('.see-content').hide();
    }

    if (jQuery('.item-tag-image').size() > 1) {
      jQuery('#media-back, #media-next').show();
    }

    if (jQuery(this).attr('media') == jQuery('.item-tag-image').size()) {
      jQuery('#media-next').hide();
    }

    if (jQuery('.item-tag-image').size() == 1) {
      jQuery('#media-back, #media-next').hide();
    }

    if (jQuery(this).attr('media') == 1) {
      jQuery('#media-back').hide();
    }
  });
  //----------------------------------------------------------------------------------------------------------------------

  let page = 1;
  let loading = true;
  const $window = jQuery(window);
  const $content = jQuery('#second-recent');
  let is_paginate = 0;
  let is_filter = 0;

  const load_posts = function (taxonomy, term, extra = null, media_type, post_per_page = 6) {
    const current_tab = getCurrentTab();
    const isCategoryFilter = isCategoryButton();

    if (current_tab == 'attachment') {
        post_per_page = 18;
    }

    media_type = current_tab;

    jQuery.ajax({
        type: 'POST',
        data: {
            action: 'load_more',
            page,
            taxonomy,
            term,
            extra,
            media_type,
            post_per_page,
        },
        dataType: 'json',
        url: window.wpGlobal_ajaxURL,
        beforeSend() {
            showLoader();
        },
        success(result) {
            hideLoader();

            if ((taxonomy != 'date') && (is_paginate || isCategoryFilter)) {
                singular_plural_found_results(result.found_posts, current_tab);
            }

            processPosts(result.data, taxonomy, media_type);

            if (result.page >= result.max_pages) {
                hideMainButton();
            }

            toggleButtons(result.max_pages, result.page, result.found_posts);
        },
    });
  };

  function getCurrentTab() {
      return jQuery('.tab-filter').filter('.current').attr('tab-name');
  }

  function isCategoryButton() {
      return jQuery('.btn__main').attr('taxonomy') == 'category' ? 1 : 0;
  }

  function showLoader() {
      let top_position_element = '.find';
      if (is_paginate) {
          top_position_element = '.secondary';
      }
      jQuery('#loader').css('top', jQuery(top_position_element).position().top + jQuery(top_position_element).height()).show();
  }

  function hideLoader() {
      jQuery('#loader').fadeOut(800);
  }

  function processPosts(posts, taxonomy, media_type) {
      jQuery(posts).each((index, value) => {
          if (taxonomy == 'category' && media_type != 'attachment') {
              processCategoryBlocks(index, value);
          } else if (media_type != 'attachment') {
              appendAndFadeInPostBlock(value);
          }

          if (media_type == 'attachment') {
              appendAttachmentBlock(value);
          }

          if (media_type == 'videos') {
              appendVideoBlock(value);
          }

          if (media_type == 'providers') {
              appendProvidersBlock(value);
          }
      });
  }

  function appendAndFadeInPostBlock(value) {
      const new_item = jQuery(build_posts_block(value)).hide();
      jQuery('.post_block > .swiper-wrapper').append(new_item);
      new_item.fadeIn(2000);
  }

  function appendAttachmentBlock(value) {
      if (is_paginate) {
          is_paginate = 0;
      }
      jQuery('#container').append(build_posts_block(value, null, 'attachment'));
  }

  function appendVideoBlock(value) {
      const block = build_posts_block(value, null, 'videos');
      jQuery('.list-video').append(block).fadeIn(1000);
  }

  function appendProvidersBlock(value) {
      const provider_block = build_posts_providers_block(value, null, 'providers');
      jQuery('.list-provider').append(provider_block);
  }

  function toggleButtons(max_pages, page, found_posts) {
      if (max_pages <= page || found_posts == 0) {
          jQuery('.btn__main, #load_more_provide').hide();
          jQuery('#load_more_provider').data('page', 1);
      } else {
          jQuery('.btn__main, #load_more_provider').show();
      }
  }

  //----------------------------------------------------------------------------------------------------------------------

  jQuery('.btn__main').on('click', function () {
    loading = true;
    page++;
    const taxonomy = jQuery(this).attr('taxonomy');
    let term = jQuery(this).attr('term');
    const media_type = jQuery(this).attr('media-type');
    const posts_per_page = jQuery(this).attr('posts_per_page');
    is_paginate = 1;
    if (taxonomy == 'date') {
      const date = jQuery(this).attr('date').split('/');
      term = JSON.stringify({ month: date[0], year: date[1] });
    }

    if (taxonomy == 'category') {
      jQuery(this).attr('page', taxonomy);
    }

    if (jQuery(this).attr('page') == 'home' && page == 2) {
      page = 3;
    }
    load_posts(taxonomy, term, check_categories(), media_type);
  });

  //----------------------------------------------------------------------------------------------------------------------

  jQuery('#media-next').on('click', function () {
    const img_id = `#media-${jQuery(this).attr('media')}`;
    slider_media(img_id);
    if (jQuery(this).attr('media') <= jQuery('.item-tag-image').size()) {
      jQuery('#media-next').attr('media', parseInt(jQuery(this).attr('media')) + 1);
      jQuery('#media-back').attr('media', parseInt(jQuery('#media-back').attr('media')) + 1);
    }

    if (jQuery(this).attr('media') == parseInt(jQuery('.item-tag-image').size()) + 1) {
      jQuery(this).hide();
    } else {
      jQuery(this).show();
    }
    check_image_post_link();
    jQuery('#media-back').show();
  });

  //----------------------------------------------------------------------------------------------------------------------

  jQuery('#media-back').on('click', function () {
    const img_id = `#media-${jQuery(this).attr('media')}`;
    if (jQuery(this).attr('media') != 0) {
      slider_media(img_id);
      jQuery('#media-back').attr('media', parseInt(jQuery(this).attr('media')) - 1);
      jQuery('#media-next').attr('media', parseInt(jQuery('#media-next').attr('media')) - 1);
    }

    if (jQuery(this).attr('media') == 0) {
      jQuery(this).hide();
    } else {
      jQuery(this).show();
    }

    check_image_post_link();
    jQuery('#media-next').show();
  });

  //----------------------------------------------------------------------------------------------------------------------

  jQuery('#media-video-next').on('click', function () {
    const video_id = jQuery(this).attr('media');
    slider_video(video_id);

    if (jQuery(this).attr('media') <= jQuery('.card-video').size()) {
      jQuery('#media-video-back').attr('media', parseInt(jQuery('#media-video-back').attr('media')) + 1);
      jQuery('#media-video-next').attr('media', parseInt(jQuery(this).attr('media')) + 1);
    }

    if (jQuery(this).attr('media') == parseInt(jQuery('.card-video').size())) {
      jQuery(this).hide();
    } else {
      jQuery(this).show();
    }

    jQuery('#media-video-back').show();
  });

  //----------------------------------------------------------------------------------------------------------------------

  jQuery('#media-video-back').on('click', function () {
    const video_id = jQuery(this).attr('media');
    slider_video(video_id);

    if (jQuery(this).attr('media') <= jQuery('.card-video').size()) {
      jQuery('#media-video-back').attr('media', parseInt(jQuery(this).attr('media')) - 1);
      jQuery('#media-video-next').attr('media', parseInt(jQuery('#media-video-next').attr('media')) - 1);
    }

    if (jQuery(this).attr('media') == 0) {
      jQuery(this).hide();
    } else {
      jQuery(this).show();
    }

    jQuery('#media-video-next').show();
  });

  //----------------------------------------------------------------------------------------------------------------------

  jQuery('.swiper-slide .inputGroup input').on('change', function () {
    if (!jQuery(this).is(':checked')) {
      jQuery(this).next().removeClass('active');
    } else {
      jQuery('.check-category').prop('checked', false);
      jQuery(this).prop('checked', true);
    }
    jQuery('.tab-content:not(.current) > .results > h3 > label').html('');
    jQuery('#container').html('');
    jQuery('.list-provider').html('');
    page = 1;
    is_paginate = 0;
    jQuery('#first-recent, .post_block > .swiper-wrapper, .list-video ').html('');
    load_posts(jQuery('.btn__main').attr('taxonomy'), jQuery('.btn__main').attr('term'), check_categories());
    is_filter = 1;
  });

  //----------------------------------------------------------------------------------------------------------------------
  jQuery('body').on('click', '.tab-filter', () => {
    if (jQuery('.btn__main').attr('taxonomy') == 'category') {
      jQuery('.list-provider').html('');
      jQuery('.tab-content:not(.current) > .results > h3 > label').html('');
      jQuery('#container').html('');
      jQuery('#first-recent, .post_block > .swiper-wrapper , .list-video').html('');
      page = 1;
      is_paginate = 0;
      load_posts(jQuery('.btn__main').attr('taxonomy'), jQuery('.btn__main').attr('term'), check_categories());
    }
  });
});

//----------------------------------------------------------------------------------------------------------------------

function check_image_post_link() {
  if (jQuery('.see-content').attr('href') == 'false') {
    jQuery('.see-content').fadeOut();
  } else {
    jQuery('.see-content').fadeIn('slow');
  }
}

//----------------------------------------------------------------------------------------------------------------------

function check_categories() {
  const cats_checked = [];
  jQuery.each(jQuery('.check-category'), function () {
    if (jQuery(this).is(':checked')) {
      cats_checked[cats_checked.length] = jQuery(this).attr('children-cat-id');
    }
  });

  return cats_checked;
}

//----------------------------------------------------------------------------------------------------------------------

function singular_plural_found_results(found_posts, current_tab) {
  let msg_post = '';
  let post_type = '';
  let post_word_gender = '';

  switch (current_tab) {
    case 'attachment':
      post_type = 'img';
      msg_post = 'image';
      msg_post += (found_posts == 1 || found_posts == 0 ? 'm' : 'n');
      post_word_gender = 'a';
      break;

    case 'videos':
      post_type = 'videos';
      msg_post = 'vídeo';
      break;

    case 'providers':
      post_type = 'providers';
      msg_post = 'fornecedor';
      msg_post += (found_posts == 1 || found_posts == 0 ? '' : 'e');
      break;

    default:
      post_type = 'subject';
      msg_post = 'matéria';
      post_word_gender = 'a';
      break;
  }

  if (found_posts == 0) {
    found_posts = 'Ops...';
    msg_post = `não encontramos nenhum${post_word_gender} ${msg_post}.`;
  }

  if (current_tab == 'videos' || current_tab == 'providers') {
    post_word_gender = 'o';
  }

  if (found_posts == 1) {
    msg_post = `${msg_post} publicad${post_word_gender}.`;
  } else if (found_posts > 1) {
    msg_post = `${msg_post}s publicad${post_word_gender}s.`;
  }

  jQuery(`#${post_type}-qtd-found`).html(found_posts);
  jQuery(`#${post_type}-qtd-found-text`).html(msg_post);
}

//----------------------------------------------------------------------------------------------------------------------

function build_posts_block(value, type, media_type) {
  if (media_type == 'attachment') {
    let img_count = jQuery('.item-tag-image ').size();
    img_count += 1;

    var block = jQuery(`<div class="item item-tag-image" media="${img_count}" id="media-${img_count}" >` +
      `<img img-post-id="${value.post_id}" img-name="${value.title}" img-url-cropped="${value.img_croped}" img-post-related="${value.post_related}" src="${value.img_croped}" alt="">` +
      `<p hidden> ${value.excerpt} </p>` +
      '</div>');
    return block;
  } else if (media_type == 'videos') {
    let video_count = jQuery('.card-video').size();
    video_count += 1;

    let block = jQuery(`<div class="card-video" media="${video_count}" id="media-video-${video_count}">` +
      `<img video-url="${value.post_permalink}" src="${value.thumbnail}" alt="${value.title}">` +
      `<h3 class="title">${value.title}</h3>` +
      `<span class="date">${value.date}</span>` +
      '</div>');
    return block;
  }

  switch (type) {
    case 'most_recent':
      var block = jQuery(`${'<article class="card small">' +
        '<a href="'}${value.post_permalink}" title="${value.title}">` +
        `<img src="${value.thumbnail}" class="attachment-posts-destaques size-posts-destaques wp-post-image" alt="" sizes="(max-width: 600px) 100vw, 600px">` +
        '</a>' +
        '<div class="card__info">' +
        `<a class="card__info-title" href="${value.category_link}" title="${value.category[0].name}">${value.category[0].name}</a>` +
        `<a class="card__info-details" href="${value.post_permalink}" title="${value.title}">${value.title}</a>` +
        `<span class="date"><a href="${value.date_link}">${value.date}</a></span>` +
        '</div>' +
        '</article>');
      break;

    default:
      var block = jQuery(`${'<div class="swiper-slide">' +
        '<a href="'}${value.post_permalink}" title="${value.title}">` +
        `<img src="${value.thumbnail}" class="attachment-posts-destaques size-posts-destaques wp-post-image" alt="" sizes="(max-width: 600px) 100vw, 600px">` +
        '</a>' +
        '<div class="info-post">' +
        `<a class="category" href="${value.category_link}" title="${value.category[0].name}">${value.category[0].name}</a>` +
        `<a class="title" href="${value.post_permalink}" title="${value.title}">${value.title}</a>` +
        `<span class="date"><a href="${value.date_link}">${value.date}</a></span>` +
        '</div>' +
        '</div>');
      break;
  }

  return block;
}
//----------------------------------------------------------------------------------------------------------------------

function process_category_blocks(index, value) {
  if (index == 0) {
    jQuery('#first-recent').hide().html('');
  }

  if (index < 3) {
    let block = build_posts_block(value, 'most_recent');
    jQuery('#first-recent').append(block).fadeIn(1000);
  } else {
    let block = build_posts_block(value);
    jQuery('.post_block > .swiper-wrapper').append(block).fadeIn(1000);
  }
}
//----------------------------------------------------------------------------------------------------------------------
function slider_media(img_id) {
  const img_url = jQuery(img_id).children('img').attr('img-url-cropped');
  const img_title = jQuery(img_id).children('img').attr('img-name');
  jQuery('.see-content').hide();

  jQuery('#img-tag-lightbox').fadeOut(() => {
    jQuery('#img-tag-lightbox').attr('src', img_url).fadeIn();
  });

  jQuery('#dv-img-tag-lightbox').show();
  jQuery('#dv-img-tag-lightbox').children('div').show();

  jQuery('#lb-img-name').fadeOut(function () {
    jQuery(this).html(img_title).fadeIn();
  });

  jQuery('#img-excerpt').hide(() => {
    jQuery('#img-excerpt').html(jQuery(img_id).children('p').html()).fadeIn();
  });

  jQuery('#img-excerpt').html(jQuery(img_id).children('p').html());

  const post_related = jQuery(img_id).children('img').attr('img-post-related');

  if (post_related != false && post_related != '') {
    jQuery('.see-content').attr('href', post_related).html('Leia a matéria');
  }
}
//----------------------------------------------------------------------------------------------------------------------

function slider_video(video_id) {
  const media_id = `#media-video-${video_id}`;

  jQuery('#lb-video-to-play').attr('src', jQuery(media_id).children('img').attr('video-url')).fadeIn();

  jQuery('#lb-info-video-name').fadeOut('800', () => {
    jQuery('#lb-info-video-name').html(jQuery(media_id).children('h3').html()).fadeIn();
  });

  jQuery('#lb-info-video-data').hide('800', () => {
    jQuery('#lb-info-video-data').html(jQuery(media_id).children('span').html()).fadeIn();
  });
}
//----------------------------------------------------------------------------------------------------------------------

function build_posts_providers_block(value, type, media_type) {
  const block = jQuery(`${'<div class="card-provider">' +
    '<figure class="card-provider__thumb">' +
    '<a href="'}${value.post_permalink}" title="${value.title}">` +
    `<img src="${value.thumbnail}" alt="">` +
    '</a>' +
    '</figure>' +
    '<div class="card-provider__info">' +
    `<a class="name" href="${value.post_permalink}" title="${value.title}">${value.title}</a>` +
    `<a href="${value.service_type_link}" ><span class="area">${value.category[0].name}</span></a>` +
    `<span class="location">${value.provider_region}</span>` +
    '</div>' +
    '</div>');
  return block;
}
